import { ISelectItem } from '@lla-platform/core/core-ui'

export enum LeadOutcomeResult {
  Unknown = 'Unknown',
  AppointmentSet = 'AppointmentSet',
  BookingMade = 'BookingMade',
  CallbackRequested = 'CallbackRequested',
  NoCommitment = 'NoCommitment',
  Declined = 'Declined'
}

export const LeadOutcomeResultToLabel: Record<string, string> = {
  Unknown: 'Unknown',
  AppointmentSet: 'Appointment Set',
  BookingMade: 'Booking Made',
  CallbackRequested: 'Callback Requested',
  NoCommitment: 'No Commitment',
  Declined: 'Declined'
}

export const LeadOutcomeResultItems: ISelectItem[] = Object.values(LeadOutcomeResult).map((value) => ({
  label: LeadOutcomeResultToLabel[value],
  value
}))
